import { Helpers, Metrics, RadioGroup, RadioGroupEvent } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';

export interface RadioGroupGridProps {
  name: string;
  value?: string;
  onChange(e: RadioGroupEvent): void;
}

const Grid = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: stretch;
  margin-left: -8px;
  margin-right: -8px;

  margin-bottom: ${Metrics.Spacing.M_X_SM}px;

  & > * {
    margin-bottom: 0;
  }

  ${Helpers.media.MD`
    margin-left: -16px;
    margin-right: -16px;
  `}

  ${Helpers.media.LG`
    margin-left: -8px;
    margin-right: -8px;
  `}

  & > div {
    position: relative;
    padding: 8px;
    flex-grow: 1;
    flex-basis: 50%;
    box-sizing: border-box;
    ${Helpers.media.MD`
      padding: 16px;
      max-width: 245px;
      min-width: 238px;
    `}
    ${Helpers.media.LG`
      min-width: 180px;
      flex-grow: 0;
      padding: 8px;
      max-width: 180px;
    `}
    ${Helpers.media.XL`
      flex-basis: 25%;
      flex-grow: 1;
    `}
    & > div {
      max-width: 300px;
    }
  }
`;

export class RadioGroupGrid extends React.Component<RadioGroupGridProps> {
  render() {
    const { name, children, value, onChange } = this.props;
    return (
      <Grid>
        <RadioGroup name={name} onChange={e => onChange(e)} value={value}>
          {children}
        </RadioGroup>
      </Grid>
    );
  }
}
